/**
 * Typed API client. Types come from the generated OpenAPI schema (`npm run api:types`).
 * Every request carries the session cookie, the CSRF token and the active organization slug.
 */
import createClient, { type Middleware } from "openapi-fetch";

import type { paths } from "./schema";

let activeOrganization: string | null = localStorage.getItem("cf.organization");

export function setActiveOrganization(slug: string | null) {
  activeOrganization = slug;
  if (slug) localStorage.setItem("cf.organization", slug);
  else localStorage.removeItem("cf.organization");
}

export function getActiveOrganization() {
  return activeOrganization;
}

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

const headers: Middleware = {
  async onRequest({ request }) {
    if (activeOrganization) request.headers.set("X-Organization", activeOrganization);
    if (!["GET", "HEAD", "OPTIONS"].includes(request.method)) {
      const token = readCookie("csrftoken");
      if (token) request.headers.set("X-CSRFToken", token);
    }
    return request;
  },
};

export const api = createClient<paths>({ baseUrl: "/", credentials: "include" });
api.use(headers);

export type ApiError = { error: { code: string; message: string; details?: unknown }; request_id?: string };

/** Normalise an openapi-fetch error into a message for the UI. */
export function errorMessage(error: unknown): string {
  if (error && typeof error === "object" && "error" in error) {
    const e = (error as ApiError).error;
    return e.message || e.code;
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}

export async function ensureCsrf() {
  if (!readCookie("csrftoken")) await api.GET("/api/v1/accounts/auth/csrf/");
}
